import React from 'react';
import wingitDesign from '../designSystem';

export default function PreFlightHeader({ navigate }) {
  const ds = wingitDesign;

  return (
    <div className="pilot-pre-flight__header" style={styles.header}>
      <button className="pilot-pre-flight__back" type="button" onClick={() => navigate('/dashboard')} style={ds.buttons.secondary}>
        Back to dashboard
      </button>

      <div style={styles.kicker}>Flight operations</div>

      <h2 style={styles.title}>Pre-flight brief</h2>

      <p style={styles.subtitle}>
        Review aircraft, route, weather, NOTAMs, planning and weight & balance before departure.
      </p>
    </div>
  );
}

const styles = {
  header: {
    marginBottom: '1.2rem',
    borderBottom: '1px solid rgba(120,180,255,0.14)',
    paddingBottom: '1rem',
  },

  kicker: {
    color: '#55c7ff',
    fontSize: '0.72rem',
    fontWeight: 900,
    letterSpacing: '0.11em',
    textTransform: 'uppercase',
    marginTop: '1rem',
  },

  title: {
    color: '#f3f8ff',
    fontWeight: 850,
    fontSize: '1.55rem',
    lineHeight: 1.15,
    margin: '0.35rem 0 0',
  },

  subtitle: {
    color: '#8db7e6',
    maxWidth: 720,
    margin: '0.55rem 0 0',
    fontSize: '0.94rem',
    lineHeight: 1.5,
  },
};